import { TooltipService } from '@ispm/shared/services/tooltip.service';
import { ComponentFactoryResolver } from '@angular/core';
import { InterpolateService } from '@ispm/shared/services/interpolate.service';

const tooltipServiceFactory = (componentFactoryResolver: ComponentFactoryResolver,
                             _interpolateService: InterpolateService) => {
  return new TooltipService(componentFactoryResolver, _interpolateService);
};

export let tooltipServiceProvider = {
    provide: TooltipService,
    useFactory: tooltipServiceFactory,
    deps: [ComponentFactoryResolver, InterpolateService]
};
